module.exports = __webpack_public_path__ + "img/forward.998a2f99.svg";